// extracted by mini-css-extract-plugin
module.exports = {"main":"badge_main__h8Whe","phAnimation":"badge_phAnimation__junPt"};